import { Markdown } from "@/components/molecules/Markdown";
import { useTypewriter } from "./ToolCallCard.tools";

export function ToolCallCardStreaming({
  text,
  isStreaming,
}: {
  text: string;
  isStreaming?: boolean;
}) {
  const displayedText = useTypewriter(text);
  const textToShow = isStreaming ? displayedText : text;

  return (
    <div className="pt-1 pb-1">
      <Markdown
        style={{
          color: "var(--muted-foreground)",
        }}
        resize={0}
      >
        {textToShow}
      </Markdown>
    </div>
  );
}
